var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.75C5.25 3.67893 6.92893 2 9 2C10.2267 2 11.3158 2.58901 12 3.49963C12.6842 2.58901 13.7733 2 15 2C17.0711 2 18.75 3.67893 18.75 5.75C18.75 6.5942 18.471 7.37325 18.0003 8H20C21.1046 8 22 8.89543 22 10V12.25H2V10C2 8.89543 2.89543 8 4 8H5.99973C5.52896 7.37325 5.25 6.5942 5.25 5.75ZM9 8H11.25V5.75C11.25 4.50736 10.2426 3.5 9 3.5C7.75736 3.5 6.75 4.50736 6.75 5.75C6.75 6.99264 7.75736 8 9 8ZM12.75 8H15C16.2426 8 17.25 6.99264 17.25 5.75C17.25 4.50736 16.2426 3.5 15 3.5C13.7574 3.5 12.75 4.50736 12.75 5.75V8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18C17 18.5072 16.8112 18.9703 16.5 19.3229C16.1888 18.9703 16 18.5072 16 18C16 17.4928 16.1888 17.0297 16.5 16.6771C16.8112 17.0297 17 17.4928 17 18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.75H2V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V13.75ZM16.5 16.6771C16.8665 16.2619 17.4027 16 18 16C19.1046 16 20 16.8954 20 18C20 19.1046 19.1046 20 18 20C17.4027 20 16.8665 19.7381 16.5 19.3229C16.1335 19.7381 15.5973 20 15 20C13.8954 20 13 19.1046 13 18C13 16.8954 13.8954 16 15 16C15.5973 16 16.1335 16.2619 16.5 16.6771Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/gift-card.0baba5ac28d57f2f1f55724238676619.svg";
export { ForwardRef as ReactComponent };